<template>
  <van-pull-refresh
    v-model="refreshing"
    @refresh="onRefresh"
    class="special_detail_container"
  >
    <van-list
      v-model="loading"
      :offset="10"
      :immediate-check="false"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoadMore"
    >
      <div class="special_info" v-if="!!specialInfo">
        <div class="special_img">
          <div class="img">
            <img
              :src="specialInfo.bigResouceUrl"
              :onerror="imgLoadError(specialInfo)"
              alt=""
            />
          </div>
        </div>
      </div>
      <news-list
        class="special_news_list"
        :contentList="specialNewsList"
        :deviceId="deviceId"
      ></news-list>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { mapState } from "vuex";
import {
  getRandomStr32,
  loadStat,
  clickPlayCount,
  addH5Escalate,
} from "@/utils";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
import NewsList from "./components/SpecialColumnNewsList";
import isJumpJs from "@/components/mixins/isJump.js";
import md5 from "js-md5";
import newsApi from "@/api/apis/news.js";
import { formatUTCDateTime } from "@/utils";
export default {
  name: "SpecialDetail",
  mixins: [isJumpJs],
  components: {
    NewsList,
  },
  data() {
    return {
      /* 设备Id */
      deviceId: null,
      refreshing: false,
      loading: false,
      finished: false,
      params: {
        contentId: null,
        memberId: null,
        pageNo: 0,
        pageSize: 20,
        sourceType: 4, //1:苹果;2:安卓;3web;4:H5
      },
      specialInfo: null,
      specialNewsList: [], //专栏新闻列表
      shareUrl: "",
      infoKey: "",
      specialId: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi
        .getWeiXinTicket({
          nodeCode: _this.nodeCode,
          url: _this.shareUrl,
        })
        .then((res) => {
          var shareImgurl = "";
          if (
            !!_this.specialInfo.imgUrl &&
            _this.specialInfo.imgUrl.length > 0
          ) {
            shareImgurl = _this.specialInfo.imgUrl;
          } else if (
            !!_this.specialInfo.bigResouceUrl &&
            _this.specialInfo.bigResouceUrl.length > 0
          ) {
            shareImgurl = _this.specialInfo.bigResouceUrl;
          }
          var desc =
            _this.specialInfo.summaryStatus && _this.specialInfo.summarySth
              ? _this.specialInfo.summarySth
              : _this.specialInfo.introduction;
          _this.$WeiXin.shareWeiXin(
            res,
            "专栏\xa0|\xa0" + _this.specialInfo.specialTitle,
            desc,
            _this.shareUrl,
            shareImgurl
          );
          this.$emit("initWeiXinTicket")
        })
        .catch((err) => {});
    },
    /* 获取专栏 */
    getSpecialContentsForColumn() {
      var _this = this;

      specialApi
        .getSpecialContentsForColumn(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            document.title = res.data.specialTitle;

            if (_this.params.pageNo == 0) {
              _this.specialNewsList = res.data.contents;
              _this.specialInfo = res.data;
              // 中宣部埋点：稿件详情页浏览（分页仅首页上报，并加 once 守卫防重复）
              _this.$track.trackPageViewOnce(
                _this.$track.EVENT_CODE.ARTICLE_DETAIL_PG,
                _this.$track.mapArticleProps(_this.specialInfo, {
                  pageName: "专栏详情页",
                  pageId: "column_detail",
                  extra: {
                    article_type: "专栏",
                    article_name: res.data.specialTitle || "",
                    special_topic_name: res.data.specialTitle || "",
                  },
                })
              );
              _this.wechatShare(); // 微信二次分享
              _this.statistics(); // 统计
            } else {
              _this.specialNewsList = _this.specialNewsList.concat(
                res.data.contents
              );
            }
            if (res.data.contents.length < _this.params.pageSize) {
              _this.finished = true;
            }
          } else {
            _this.$toast({
              message: res.message,
              position: "center",
            });
          }
        })
        .catch((err) => {
          // _this.$toast({
          //   message: "接口调用出错",
          //   position: "center",
          // });
        });
    },
    async getPreviewDetail() {
      try {
        const paramsDto = {
          infoKey: this.infoKey,
        };
        const res = await newsApi.getNewsInfo(JSON.stringify(paramsDto));
        console.log(res, "====res");
        if (res.suc == 1) {
          const specialId = res.data.contentId;
          const info = res.data?.materialInfo || {};
          this.specialId = specialId;
          info.creationTime = formatUTCDateTime(info.creationTime);
          info.firstAppPublishTime = formatUTCDateTime(
            info.firstAppPublishTime
          );
          document.title = res.data.materialInfo.title;
          this.specialInfo = {
            ...info,
            ...res.data,
          };
          this.getSpecialContentsForColumnPage();
        } else {
          this.$toast({
            message: res.message || "接口调用出错",
            position: "center",
          });
        }
      } catch (err) {
        this.$toast({
          message: err.message || "接口调用出错",
          position: "center",
        });
      }
    },
    async getSpecialContentsForColumnPage() {
      try {
        const reqParams = {
          specialId: this.specialId,
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize,
        };
        const result = await newsApi.getSpecialContentsForColumnPage(reqParams);
        this.specialNewsList = result.data.contents;
        if (this.specialNewsList.length < this.params.pageSize) {
          this.finished = true;
        }
      } catch (err) {
        this.$message(err.message);
      }
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.specialNewsList = [];
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      if (this.infoKey) {
        this.getSpecialContentsForColumnPage();
      } else {
        this.getSpecialContentsForColumn(); // 获取专栏
      }
    },
    /* 上拉加载 */
    onLoadMore() {
      this.params.pageNo++;
      this.loading = true;
      if (this.infoKey) {
        this.getSpecialContentsForColumnPage();
      } else {
        this.getSpecialContentsForColumn(); // 获取专栏
      }
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.specialInfo.contentCreationTime, // 创建时间
        contentId: this.specialInfo.id, // 专题Id
        contentTitle: this.specialInfo.specialTitle,
        contentType: 7,
        memberId: this.specialInfo.memberId, // 当前稿件的编辑者的id
        nickName: this.specialInfo.nickName, // 当前稿件的编辑者的用户名称
      };
      if (!!this.specialInfo.channelId && this.specialInfo.channelId > 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.specialInfo.channelId, // 栏目id
          channelName: this.specialInfo.channelName, // 栏目名称
        });
      }
      if (this.relayParams && this.relayParams.uik) {
        tj_params.uik = this.relayParams.uik;
        tj_params.share_plat = this.relayParams.share_plat;
        let sec = md5(
          tj_params.uik +
            this.specialInfo.id +
            tj_params.contentType +
            tj_params.share_plat
        );
        sec = sec.substring(0, 8);
        tj_params.sec = sec;
      }
      clickPlayCount(tj_params);
      addH5Escalate();
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.params.contentId = Number(query.contentId);
      if (!!this.userInfo) {
        this.params.memberId = this.userInfo.id;
      } else {
        this.deviceId = getRandomStr32();
      }
      if (query.infoKey) {
        this.infoKey = query.infoKey;
        this.getPreviewDetail();
      } else {
        this.getSpecialContentsForColumn(); // 获取专栏
        loadStat(); // 友盟统计
      }
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
};
</script>
<style scoped lang="scss">
.special_detail_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .special_info {
    background-color: #fff;
    .special_img {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(~@/assets/images/default_pic_16_9.png);
      overflow: hidden;
      .img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        img {
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
    }
  }
  .special_news_list {
    padding: 0 15px;
  }
}
</style>
